var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a42fe323-49f0-4f1d-b93f-cb998ec05fa0{fill:#555;}")),React.createElement("polygon",{"className":"a42fe323-49f0-4f1d-b93f-cb998ec05fa0","points":"2.364 0 2.364 2 9.364 2 9.364 9 11.364 9 11.364 0 2.364 0","key":1}),React.createElement("rect",{"className":"a42fe323-49f0-4f1d-b93f-cb998ec05fa0","x":"-1.197","y":"5.061","width":"13","height":"2","transform":"translate(-2.732 5.525) rotate(-45)","key":2})]);
}

ExternalLink.defaultProps = {"id":"e39064fb-64f9-40a2-8f43-4219b302e6c9","data-name":"Layer 1","width":"11.364","height":"11.364","viewBox":"0 0 11.364 11.364"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
